import {
  TT_DON_KINH,
  TT_PHIEU_KHAM,
  TT_PHIEU_KHO,
  TT_PHIEU_VTYT,
  tabKeys,
} from "types/enums";
import {NGUON_VTYT} from "types/enums/medical-supplies-store";
import {residentialNurse} from "types/enums/residential-nurse";
import {
  BO_PHAN_MUA_SAM,
  CHI_PHI_CHINH,
  DIA_DIEM_MUA_SAM,
  NGUON_THANH_TOAN,
  TRANG_THAI_MUA_SAM,
} from "types/enums/shopping";

const listGender = [
  {
    value: 0,
    label: "Nam",
  },
  {
    value: 1,
    label: "Nữ",
  },
];

const listMarriage = [
  {
    value: "Chưa kết hôn",
    label: "Chưa kết hôn",
  },
  {
    value: "Sống chung chưa kết hôn",
    label: "Sống chung chưa kết hôn",
  },
  {
    value: "Đang có vợ/chồng",
    label: "Đang có vợ/chồng",
  },
  {
    value: "Góa",
    label: "Góa",
  },
  {
    value: "Ly thân",
    label: "Ly thân",
  },
  {
    value: "Ly hôn",
    label: "Ly hôn",
  },
];
const listClassification = [
  {
    value: "Trung bình",
    label: "Trung bình",
  },
  {
    value: "Trung bình khá",
    label: "Trung bình khá",
  },
  {
    value: "Khá",
    label: "Khá",
  },
  {
    value: "Giỏi",
    label: "Giỏi",
  },
  {
    value: "Xuất sắc",
    label: "Xuất sắc",
  },
];
const listTTPhieuKho = [
  {value: TT_PHIEU_KHO.NHAP, label: "Nháp"},
  {value: TT_PHIEU_KHO.CHO_DUYET, label: "Chờ duyệt"},
  // {value: TT_PHIEU_KHO.DA_DUYET, label: "Đã duyệt"},
  {value: TT_PHIEU_KHO.HOAN_THANH, label: "Hoàn thành"},
  {value: TT_PHIEU_KHO.HUY_PHIEU, label: "Hủy"},
  {value: TT_PHIEU_KHO.TU_CHOI, label: "Từ chối"},
];
const listTTPhieuKham = [
  {value: TT_PHIEU_KHAM.PKM, label: "Phiếu khám mới"},
  {value: TT_PHIEU_KHAM.CTH, label: "Chờ thực hiện"},
  // {value: TT_PHIEU_KHAM.DA_DUYET, label: "Đã duyệt"},
  {value: TT_PHIEU_KHAM.DTH, label: "Đang thực hiện"},
  {value: TT_PHIEU_KHAM.HT, label: "Hoàn thành"},
  {value: TT_PHIEU_KHAM.CKQ, label: "Chờ kết quả xét nghiệm"},
  {value: TT_PHIEU_KHAM.DCKQ, label: "Đã có kết quả xét nghiệm"},
  {value: TT_PHIEU_KHAM.H, label: "Hủy thực hiện"},
  {value: TT_PHIEU_KHAM.X, label: "Đã xóa"},
];
const listTT_ThuocKho: any[] = [
  {
    value: "HH",
    label: "Hết hàng",
  },
  {
    value: "CH",
    label: "Còn hàng",
  },
  {
    value: "TL",
    label: "Tồn lâu",
  },
  {
    value: "GH",
    label: "Hết hàng",
  },
];
const listNhomThuoc = [
  {value: 1, label: "Thuốc tự chi trả"},
  {value: 2, label: "Thuốc bảo hiểm"},
];
const listTTPhieuVTYT = [
  {value: TT_PHIEU_VTYT.NHAP, label: "Nháp"},
  {value: TT_PHIEU_VTYT.CHO_DUYET, label: "Chờ duyệt"},
  {value: TT_PHIEU_VTYT.HOAN_THANH, label: "Hoàn thành"},
  {value: TT_PHIEU_VTYT.CANH_BAO, label: "Cảnh báo"},
  {value: TT_PHIEU_VTYT.TU_CHOI, label: "Từ chối"},
  {value: TT_PHIEU_VTYT.HUY, label: "Hủy"},
];
const listNguonVTYT = [
  {value: NGUON_VTYT.TCT, label: NGUON_VTYT.TCT},
  {value: NGUON_VTYT.BH, label: NGUON_VTYT.BH},
  {value: NGUON_VTYT.TH, label: NGUON_VTYT.TH},
  {value: NGUON_VTYT.KH, label: NGUON_VTYT.KH},
];
const listTT_Don_Kinh = [
  {value: TT_DON_KINH.CHUA_BAN, label: "Chưa bán"},
  {value: TT_DON_KINH.DA_BAN, label: "Đã bán"},

  {value: TT_DON_KINH.HUY, label: "Hủy"},
  {value: TT_DON_KINH.HOAN_LAI, label: "Đã hoàn lại"},
];
const listBacSy1 = [
  {value: "Trần Minh Hà", label: "Trần Minh Hà"},
  {value: "Nguyễn Thị Mai Phương", label: "Nguyễn Thị Mai Phương"},
  {value: "Đàm Văn Quý", label: "Đàm Văn Quý"},
  {value: "Nguyễn Thị Thu Hương", label: "Nguyễn Thị Thu Hương"},
  {value: "Đỗ Thị Liên", label: "Đỗ Thị Liên"},
  {value: "Hoàng Thị Hạnh", label: "Hoàng Thị Hạnh"},
  {value: "Nguyễn Lê Ngọc Khanh", label: "Nguyễn Lê Ngọc Khanh"},
  {value: "Nguyễn Thị Phương", label: "Nguyễn Thị Phương"},
  {value: "La Kim Luân", label: "La Kim Luân"},
  {value: "Phạm Chu Long Gia", label: "Phạm Chu Long Gia"},
];
const listBacSy2 = [
  {value: "Trần Thị Vân Anh", label: "Trần Thị Vân Anh"},
  {value: "Nguyễn Quỳnh Chi", label: "Nguyễn Quỳnh Chi"},
  {value: "Trần Thị Thanh Huyền", label: "Trần Thị Thanh Huyền"},

  {value: "Nguyễn Thị Thanh Hằng", label: "Nguyễn Thị Thanh Hằng"},
  {value: "Đỗ Thị Dịu", label: "Đỗ Thị Dịu"},
  {value: "Lê Thị Thu Lan", label: "Lê Thị Thu Lan"},
  {value: "Dương Thị Kiều Nga", label: "Dương Thị Kiều Nga"},
  // {value: "Nguyễn Thị Thanh Nhàn", label: "Nguyễn Thị Thanh Nhàn"},
  {value: "Vũ Thị Hân", label: "Vũ Thị Hân"},
  {value: "Phạm Thị Hương Giang", label: "Phạm Thị Hương Giang"},
  {value: "Đỗ Thị Tú Linh", label: "Đỗ Thị Tú Linh"},
  {value: "Đàm Thị Nhài", label: "Đàm Thị Nhài"},
  {value: "Trần Thị Hằng", label: "Trần Thị Hằng"},
  {value: "Nguyễn Thu Hương", label: "Nguyễn Thu Hương"},

  {value: "Nguyễn Thị Minh Khuê", label: "Nguyễn Thị Minh Khuê"},

  // {value: "Nguyễn Thị Thanh", label: "Nguyễn Thị Thanh"},
];
const listMenu = [
  {value: "tiepNhan", label: "Tiếp nhận"},
  {value: "benhNhanCu", label: "Thông tin BN cũ"},
  {value: "thanhToan", label: "Thanh toán"},
  {value: "dayDuLieuXml", label: "Đẩy dữ liệu XML"},
  {value: "ketXuatXml", label: "Kết luận XML"},
  {value: "khucXa", label: "Khúc xạ"},
  {value: "dieuDuongNgoaiTru", label: "Điều dưỡng ngoại trú"},
  {value: "khamBenh", label: "Khám bệnh ngoại trú"},
  {value: "xetNghiem", label: "Xét nghiệm"},
  {value: "chanDoan", label: "Chẩn đoán"},
  {value: "dienTim", label: "Điện tim"},
  {value: "dieuDuongNoiTru", label: "Điều dưỡng nội trú"},
  {value: "dieuTri", label: "Điều trị"},
  {value: "phauThuat", label: "Phẫu thuật"},
  {value: "tuVanDieuTri", label: "Tư vấn điều trị"},
  {value: "cskh", label: "Chăm sóc khách hàng"},
  {value: "theKham", label: "Thẻ khám và chương trình ưu đãi"},
  {value: "dichVuKiThuat", label: "Dịch vụ kĩ thuật"},
  {value: "goiDichVu", label: "Gói dịch vụ"},
  {value: "nhaThuoc", label: "Nhà thuốc"},
  {value: "khoDuoc", label: "Kho dược"},
  {value: "khoVatTu", label: "Kho vật tư"},
  {value: "quayKinh", label: "Quầy kính"},
  {value: "khoKinh", label: "Kho kính"},
  {value: "nhanVien", label: "Danh sách nhân viên"},
  {value: "kyLuat", label: "Kỷ luật"},
  {value: "congChuan", label: "Công chuẩn tháng"},
  {value: "tuyenDung", label: "Đợt tuyển dụng"},
  {value: "ungVien", label: "Danh mục ứng viên"},
  {value: "khoaDaoTao", label: "Khóa đào tạo"},
  {value: "caLamViec", label: "Ca làm việc"},
  {value: "chamCongTho", label: "Chấm công thô"},
  {value: "chamCong", label: "Chấm công"},
  {value: "theoDoiNghiBu", label: "Theo dõi nghỉ bù"},
  {value: "theoDoiDiMuon", label: "Theo dõi đi muộn"},
  {value: "nghiPhep", label: "Đăng kí nghỉ phép"},
  {value: "lamThem", label: "Chấm công làm thêm giờ"},
  {value: "bangLuong", label: "Bảng lương"},
  {value: "bhxh", label: "Theo dõi BHXH"},
  {value: "caiDatLuong", label: "Cài đặt lương"},
  {value: "duyetBangLuong", label: "Duyệt bảng lương"},
  {value: "danhMucTrangThaiDuyet", label: "Danh mục trạng thái duyệt"},
  {value: "khaiBaoQuyenDuyet", label: "Khai báo quyền duyệt"},
  {value: "khaiBaoNguoiDuyet", label: "Khai báo người duyệt"},
  {value: "thue", label: "Biểu thuế TNCN"},
  {value: "vanBan", label: "Quản lý văn bản"},
  {value: "baoCaoDoanhThu", label: "Báo cáo doanh thu"},
  {value: "baoCaoKho", label: "Báo cáo kho"},
  {value: "baoCaoTongHop", label: "Báo cáo tổng hợp"},
  {value: "phanQuyen", label: "Phân quyền"},
  {value: "kyBaoMat", label: "Ký bảo mật"},
  {value: "deNghiMuaSam", label: "Đề nghị mua sắm"},
  {value: "deNghiThanhToan", label: "Đề nghị thanh toán"},
  // {value: "danhMucChung", label: "Danh mục dùng chung"},
];
const listTab = [
  // TIẾP NHẬN
  {
    menuKey: "tiepNhan",
    tabKey: tabKeys.RECEIVE.TAB_1,
    tab: "Đã tiếp nhận",
  },
  {
    menuKey: "tiepNhan",
    tabKey: tabKeys.RECEIVE.TAB_2,
    tab: "Tiếp nhận",
  },
  {
    menuKey: "tiepNhan",
    tabKey: tabKeys.RECEIVE.TAB_4,
    tab: "Quản lý danh sách thẻ",
  },
  {
    menuKey: "tiepNhan",
    tabKey: tabKeys.RECEIVE.TAB_5,
    tab: "Lịch sử khám bệnh",
  },
  {
    menuKey: "tiepNhan",
    tabKey: tabKeys.RECEIVE.TAB_6,
    tab: "Mua thẻ khám bệnh",
  },
  {
    menuKey: "tiepNhan",
    tabKey: tabKeys.RECEIVE.REPORT,
    tab: "Báo cáo OPD",
  },
  // THÔNG TIN BN CŨ
  {
    menuKey: "benhNhanCu",
    tabKey: tabKeys.SEARCH_PATIENT.LIST_PATIENT,
    tab: "Danh sách bệnh nhân",
  },
  {
    menuKey: "benhNhanCu",
    tabKey: tabKeys.SEARCH_PATIENT.DETAIL,
    tab: "Thông tin bệnh nhân",
  },

  {
    menuKey: "benhNhanCu",
    tabKey: tabKeys.SEARCH_PATIENT.HISTORY,
    tab: "Lịch sử khám bệnh",
  },
  // THANH TOÁN
  {
    menuKey: "thanhToan",
    tabKey: tabKeys.PAY.LIST_PENDING,
    tab: "Danh sách chờ",
  },
  {
    menuKey: "thanhToan",
    tabKey: tabKeys.PAY.PAY_TAB,
    tab: "Thanh toán",
  },
  {
    menuKey: "thanhToan",
    tabKey: tabKeys.PAY.HISTORY,
    tab: "Lịch sử khám bệnh",
  },
  {
    menuKey: "thanhToan",
    tabKey: tabKeys.PAY.REPORT,
    tab: "Báo cáo",
  },
  // KHÚC XẠ
  {
    menuKey: "khucXa",
    tabKey: tabKeys.REFRACTION.REFRACTION_LIST,
    tab: "Danh sách bệnh nhân",
  },
  {
    menuKey: "khucXa",
    tabKey: tabKeys.REFRACTION.REFRACTION_INFO,
    tab: "Chi tiết thông tin",
  },
  {
    menuKey: "khucXa",
    tabKey: tabKeys.REFRACTION.HISTORY_REFRACTION,
    tab: "Lịch sử khám bệnh",
  },
  {
    menuKey: "khucXa",
    tabKey: tabKeys.REFRACTION.REPORT_ORTHOR_K,
    tab: "Theo dõi BN Ortho K",
  },

  // ĐIỀU DƯỠNG NGOẠI TRÚ
  {
    menuKey: "dieuDuongNgoaiTru",
    tabKey: tabKeys.NURSE_OUT.LIST_PATIENT,
    tab: "Danh sách bệnh nhân",
  },
  {
    menuKey: "dieuDuongNgoaiTru",
    tabKey: tabKeys.NURSE_OUT.DETAIL_PATIENT,
    tab: "Chi tiết thông tin",
  },
  {
    menuKey: "dieuDuongNgoaiTru",
    tabKey: tabKeys.NURSE_OUT.EXAM_HISTORY,
    tab: "Lịch sử khám bệnh",
  },
  {
    menuKey: "dieuDuongNgoaiTru",
    tabKey: tabKeys.NURSE_OUT.CATALOG,
    tab: "Cấu hình danh mục điều dưỡng",
  },

  // KHÁM BỆNH NGOẠI TRÚ
  {
    menuKey: "khamBenh",
    tabKey: tabKeys.EXAMINATION.LIST_EXAM,
    tab: "Danh sách khám bệnh",
  },
  {
    menuKey: "khamBenh",
    tabKey: tabKeys.EXAMINATION.INFOR_DETAIL,
    tab: "Chi tiết thông tin",
  },
  {
    menuKey: "khamBenh",
    tabKey: tabKeys.EXAMINATION.EXAM_HISTORY,
    tab: "Lịch sử khám bệnh",
  },
  {
    menuKey: "khamBenh",
    tabKey: tabKeys.EXAMINATION.REPORT,
    tab: "Báo cáo",
  },

  // XÉT NGHIỆM
  {
    menuKey: "xetNghiem",
    tabKey: tabKeys.ANALYSIS.LIST_PATIENT_ANALYSIS,
    tab: "Danh sách bệnh nhân",
  },
  {
    menuKey: "xetNghiem",
    tabKey: tabKeys.ANALYSIS.DETAIL_PATIENT_ANALYSIS,
    tab: "Chi tiết thông tin",
  },
  {
    menuKey: "xetNghiem",
    tabKey: tabKeys.ANALYSIS.HISTORY_ANALYSIS,
    tab: "Lịch sử khám bệnh",
  },
  {
    menuKey: "xetNghiem",
    tabKey: tabKeys.ANALYSIS.CATEGORY_ANALYSIS,
    tab: "Cấu hình danh mục xét nghiệm",
  },
  {
    menuKey: "xetNghiem",
    tabKey: tabKeys.ANALYSIS.BOOK_ANALYSIS,
    tab: "Sổ xét nghiệm lâm sàng",
  },

  // CHẨN ĐOÁN
  {
    menuKey: "chanDoan",
    tabKey: tabKeys.DIAGNOSE.LIST_PATIENT,
    tab: "Danh sách bệnh nhân",
  },
  {
    menuKey: "chanDoan",
    tabKey: tabKeys.DIAGNOSE.DETAIL_INFO,
    tab: "Chi tiết thông tin",
  },
  {
    menuKey: "chanDoan",
    tabKey: tabKeys.DIAGNOSE.EXAM_HISTORY,
    tab: "Lịch sử khám bệnh",
  },
  {
    menuKey: "chanDoan",
    tabKey: tabKeys.DIAGNOSE.CATALOG,
    tab: "Cấu hình danh mục CĐHA",
  },

  // ĐIỆN TIM
  {
    menuKey: "dienTim",
    tabKey: tabKeys.ELECTROCARDIOGRAPHY.LIST_PATIENT,
    tab: "Danh sách bệnh nhân",
  },
  {
    menuKey: "dienTim",
    tabKey: tabKeys.ELECTROCARDIOGRAPHY.DETAIL_INFO_ELECTRO,
    tab: "Chi tiết thông tin",
  },
  {
    menuKey: "dienTim",
    tabKey: tabKeys.ELECTROCARDIOGRAPHY.EXAM_HISTORY,
    tab: "Lịch sử khám bệnh",
  },
  {
    menuKey: "dienTim",
    tabKey: tabKeys.ELECTROCARDIOGRAPHY.CATALOG,
    tab: "Cấu hình danh mục điện tim",
  },

  // ĐIỀU DƯỠNG NỘI TRÚ
  {
    menuKey: "dieuDuongNoiTru",
    tabKey: residentialNurse.NURSING.LIST_PATIENT,
    tab: "Danh sách bệnh nhân",
  },
  {
    menuKey: "dieuDuongNoiTru",
    tabKey: residentialNurse.NURSING.COME_IN_HOSPITAL_INFO,
    tab: "Thông tin nhập viện",
  },
  {
    menuKey: "dieuDuongNoiTru",
    tabKey: residentialNurse.NURSING.TREATMENT_INFO,
    tab: "Thông tin điều trị",
  },
  {
    menuKey: "dieuDuongNoiTru",
    tabKey: residentialNurse.NURSING.COME_OUT_HOSPITAL_INFO,
    tab: "Thông tin xuất viện",
  },
  {
    menuKey: "dieuDuongNoiTru",
    tabKey: residentialNurse.NURSING.EXAMINE_HISTORY,
    tab: "Lịch sử khám bệnh",
  },
  {
    menuKey: "dieuDuongNoiTru",
    tabKey: residentialNurse.NURSING.SICK_BED_CATALOG,
    tab: "Danh mục giường bệnh",
  },

  // ĐIỀU TRỊ
  {
    menuKey: "dieuTri",
    tabKey: residentialNurse.TREATMENT.LIST_PATIENT,
    tab: "Danh sách nội trú",
  },
  {
    menuKey: "dieuTri",
    tabKey: residentialNurse.TREATMENT.TREATMENT_INFO,
    tab: "Thông tin điều trị",
  },
  {
    menuKey: "dieuTri",
    tabKey: residentialNurse.TREATMENT.EXAM_HISTORY,
    tab: "Lịch sử khám bệnh",
  },

  // PHẪU THUẬT
  {
    menuKey: "phauThuat",
    tabKey: residentialNurse.SURGERY.LIST_PATIENT,
    tab: "Danh sách bệnh nhân",
  },
  {
    menuKey: "phauThuat",
    tabKey: residentialNurse.SURGERY.INFO_DETAIL,
    tab: "Chi tiết thông tin",
  },
  {
    menuKey: "phauThuat",
    tabKey: residentialNurse.SURGERY.EXAM_HISTORY,
    tab: "Lịch sử khám bệnh",
  },
  {
    menuKey: "phauThuat",
    tabKey: residentialNurse.SURGERY.ADVANCE_SETTING,
    tab: "Cấu hình danh mục phẫu thuật",
  },

  // TƯ VẤN ĐIỀU TRỊ
  {
    menuKey: "tuVanDieuTri",
    tabKey: tabKeys.CONSULTANT_AND_FRAGMENT.LIST_CONSULTANT_AND_FRAGMENT,
    tab: "BN chờ tư vấn",
  },
  {
    menuKey: "tuVanDieuTri",
    tabKey: tabKeys.CONSULTANT_AND_FRAGMENT.APPOITMENT,
    tab: "BN có lịch PT",
  },
  {
    menuKey: "tuVanDieuTri",
    tabKey: tabKeys.CONSULTANT_AND_FRAGMENT.DETAIL_CONSULTANT_AND_FRAGMENT,
    tab: "Chi tiết thông tin",
  },
  {
    menuKey: "tuVanDieuTri",
    tabKey: tabKeys.CONSULTANT_AND_FRAGMENT.HISTORY_EXAMINE,
    tab: "Lịch sử khám bệnh",
  },
  {
    menuKey: "tuVanDieuTri",
    tabKey: tabKeys.CONSULTANT_AND_FRAGMENT.REPORT,
    tab: "DS bệnh nhân đã phẫu thuật",
  },

  // CHĂM SÓC KHÁCH HÀNG
  {
    menuKey: "cskh",
    tabKey: tabKeys.CUSTOMER_CARE.CARE,
    tab: "Danh sách khách hàng",
  },
  {
    menuKey: "cskh",
    tabKey: tabKeys.CUSTOMER_CARE.EXAMINATION_HISTORY,
    tab: "Lịch sử khám bệnh",
  },
  {
    menuKey: "cskh",
    tabKey: tabKeys.CUSTOMER_CARE.CSKH_MANAGEMENT,
    tab: "Quản lý danh mục CSKH",
  },

  // THẺ KHÁM VÀ CHƯƠNG TRÌNH ƯU ĐÃI
  {
    menuKey: "theKham",
    tabKey: tabKeys.CARD_AND_OFFER.CARD_TYPES,
    tab: "Loại thẻ khám",
  },
  {
    menuKey: "theKham",
    tabKey: tabKeys.CARD_AND_OFFER.DISCOUNTS,
    tab: "Chương trình ưu đãi",
  },

  // DỊCH VỤ KỸ THUẬT
  {
    menuKey: "dichVuKiThuat",
    tabKey: tabKeys.TECHNICAL_SERVICE.TECHNICAL_SERVICE,
    tab: "Dịch vụ kỹ thuật",
  },
  {
    menuKey: "dichVuKiThuat",
    tabKey: tabKeys.TECHNICAL_SERVICE.CATALOG,
    tab: "Danh mục",
  },

  // QUẦY KINH
  {
    menuKey: "quayKinh",
    tabKey: tabKeys.GLASSES.TAB_1,
    tab: "Danh sách đơn kính",
  },
  {
    menuKey: "quayKinh",
    tabKey: tabKeys.GLASSES.TAB_2,
    tab: "Chi tiết đơn kính",
  },
  {
    menuKey: "quayKinh",
    tabKey: tabKeys.GLASSES.HISTORY_TAB,
    tab: "Lịch sử khám bệnh",
  },

  // KHO KINH
  {
    menuKey: "khoKinh",
    tabKey: tabKeys.GLASSES_STOREHOUSE.STORE_GLASS,
    tab: "Kho kính",
  },
  {
    menuKey: "khoKinh",
    tabKey: tabKeys.GLASSES_STOREHOUSE.IMPORT,
    tab: "Phiếu nhập",
  },
  {
    menuKey: "khoKinh",
    tabKey: tabKeys.GLASSES_STOREHOUSE.EXPORT,
    tab: "Phiếu xuất",
  },
  {
    menuKey: "khoKinh",
    tabKey: tabKeys.GLASSES_STOREHOUSE.DETAIL,
    tab: "Chi tiết phiếu",
  },
  {
    menuKey: "khoKinh",
    tabKey: tabKeys.GLASSES_STOREHOUSE.CATALOG,
    tab: "Cấu hình hệ thống",
  },

  // NHÀ THUỐC
  {
    menuKey: "nhaThuoc",
    tabKey: tabKeys.MEDICINE_STORE.LIST_PRESCRIPTION,
    tab: "Danh sách đơn thuốc",
  },
  {
    menuKey: "nhaThuoc",
    tabKey: tabKeys.MEDICINE_STORE.PRESCRIPTION_DETAIL,
    tab: "Chi tiết đơn thuốc",
  },
  {
    menuKey: "nhaThuoc",
    tabKey: tabKeys.MEDICINE_STORE.ALLOCATION,
    tab: "Cấp phát thuốc",
  },

  // KHO DƯỢC
  {
    menuKey: "khoDuoc",
    tabKey: tabKeys.PHARMACY_STORE.LIST_PHARMACY,
    tab: "Kho dược",
  },
  {
    menuKey: "khoDuoc",
    tabKey: tabKeys.PHARMACY_STORE.IMPORT,
    tab: "Phiếu nhập",
  },
  {
    menuKey: "khoDuoc",
    tabKey: tabKeys.PHARMACY_STORE.EXPORT,
    tab: "Phiếu xuất",
  },
  {
    menuKey: "khoDuoc",
    tabKey: tabKeys.PHARMACY_STORE.RESERVE,
    tab: "Phiếu dự trù",
  },
  {
    menuKey: "khoDuoc",
    tabKey: tabKeys.PHARMACY_STORE.DETAIL,
    tab: "Chi tiết phiếu",
  },
  {
    menuKey: "khoDuoc",
    tabKey: tabKeys.PHARMACY_STORE.INVENTORY,
    tab: "Phiếu kiểm kê",
  },
  {
    menuKey: "khoDuoc",
    tabKey: tabKeys.PHARMACY_STORE.INVENTORY_DETAIL,
    tab: "Chi tiết kiểm kê",
  },
  {
    menuKey: "khoDuoc",
    tabKey: tabKeys.PHARMACY_STORE.REPORT,
    tab: "Báo cáo nâng cao",
  },
  {
    menuKey: "khoDuoc",
    tabKey: tabKeys.PHARMACY_STORE.BID_DEADLINE,
    tab: "Xem hạn thầu",
  },
  {
    menuKey: "khoDuoc",
    tabKey: tabKeys.PHARMACY_STORE.CATALOG,
    tab: "Cấu hình hệ thống",
  },

  // KHO VẬT TƯ
  {
    menuKey: "khoVatTu",
    tabKey: tabKeys.MEDICAL_SUPPLIES_STORE.LIST_PHARMACY,
    tab: "Kho vật tư",
  },
  {
    menuKey: "khoVatTu",
    tabKey: tabKeys.MEDICAL_SUPPLIES_STORE.IMPORT,
    tab: "Phiếu nhập",
  },
  {
    menuKey: "khoVatTu",
    tabKey: tabKeys.MEDICAL_SUPPLIES_STORE.EXPORT,
    tab: "Phiếu xuất",
  },
  {
    menuKey: "khoVatTu",
    tabKey: tabKeys.MEDICAL_SUPPLIES_STORE.RESERVE,
    tab: "Phiếu dự trù",
  },
  {
    menuKey: "khoVatTu",
    tabKey: tabKeys.MEDICAL_SUPPLIES_STORE.DETAIL,
    tab: "Chi tiết phiếu",
  },
  {
    menuKey: "khoVatTu",
    tabKey: tabKeys.MEDICAL_SUPPLIES_STORE.INVENTORY,
    tab: "Phiếu kiểm kê",
  },
  {
    menuKey: "khoVatTu",
    tabKey: tabKeys.MEDICAL_SUPPLIES_STORE.INVENTORY_DETAIL,
    tab: "Chi tiết kiểm kê",
  },
  {
    menuKey: "khoVatTu",
    tabKey: tabKeys.MEDICAL_SUPPLIES_STORE.REPORT,
    tab: "Báo cáo nâng cao",
  },
  {
    menuKey: "khoVatTu",
    tabKey: tabKeys.MEDICAL_SUPPLIES_STORE.BID_DEADLINE,
    tab: "Xem hạn thầu",
  },
  {
    menuKey: "khoVatTu",
    tabKey: tabKeys.MEDICAL_SUPPLIES_STORE.CATALOG,
    tab: "Cấu hình hệ thống",
  },

  // DANH SÁCH NHÂN VIÊN
  {
    menuKey: "nhanVien",
    tabKey: tabKeys.EMPLOYEE.LIST_EMPLOYEE,
    tab: "Danh sách nhân viên",
  },
  {
    menuKey: "nhanVien",
    tabKey: tabKeys.EMPLOYEE.DETAIL,
    tab: "Chi tiết thông tin",
  },
  {
    menuKey: "nhanVien",
    tabKey: tabKeys.EMPLOYEE.CONTRACT,
    tab: "Hợp đồng lao động",
  },
  {
    menuKey: "nhanVien",
    tabKey: tabKeys.EMPLOYEE.LICENSE,
    tab: "Giấy phép hành nghề",
  },
  {
    menuKey: "nhanVien",
    tabKey: tabKeys.EMPLOYEE.CATALOG,
    tab: "Cấu hình danh mục",
  },

  // KHÓA ĐÀO TẠO
  {
    menuKey: "khoaDaoTao",
    tabKey: tabKeys.TRAINING.LIST_TRAINNING,
    tab: "Khóa đào tạo",
  },
  {
    menuKey: "khoaDaoTao",
    tabKey: tabKeys.TRAINING.HISTORY_TRAINING,
    tab: "Lịch sử đào tạo",
  },

  // CA LÀM VIỆC
  {
    menuKey: "caLamViec",
    tabKey: tabKeys.SHIFT.DIVISION_WORK,
    tab: "Phân ca làm việc",
  },
  {
    menuKey: "caLamViec",
    tabKey: tabKeys.SHIFT.CONFIGURE_WORK_SHIFT,
    tab: "Cấu hình ca làm việc",
  },

  // QUẢN LÝ VĂN BẢN
  {
    menuKey: "vanBan",
    tabKey: tabKeys.TEXT.TEXTARRIVE,
    tab: "Văn bản đi",
  },
  {
    menuKey: "vanBan",
    tabKey: tabKeys.TEXT.TEXTAWAY,
    tab: "Văn bản đến",
  },

  // BÁO CÁO DOANH THU
  {
    menuKey: "baoCaoDoanhThu",
    tabKey: tabKeys.REVENUES_REPORT.REVENUES_IN_ITEM,
    tab: "Doanh thu theo Item",
  },
  {
    menuKey: "baoCaoDoanhThu",
    tabKey: tabKeys.REVENUES_REPORT.REVENUES_IN_CUSTOMER,
    tab: "Doanh thu theo KH",
  },
  {
    menuKey: "baoCaoDoanhThu",
    tabKey: tabKeys.REVENUES_REPORT.REVENUES_IN_SURGERY,
    tab: "Doanh thu theo phẫu thuật",
  },

  // BÁO CÁO KHO
  {
    menuKey: "baoCaoKho",
    tabKey: tabKeys.STORE_REPORT.ALL_REPORT,
    tab: "Kho-sổ tổng hợp",
  },
  {
    menuKey: "baoCaoKho",
    tabKey: tabKeys.STORE_REPORT.DETAIL_REPORT,
    tab: "Kho-sổ chi tiết",
  },

  // BÁO CÁO TỔNG HỢP
  {
    menuKey: "baoCaoTongHop",
    tabKey: tabKeys.COMBINE_REPORT.PHAU_THUAT_REPORT,
    tab: "Phẫu thuật",
  },
  {
    menuKey: "baoCaoTongHop",
    tabKey: tabKeys.COMBINE_REPORT.KHAM_MAT_REPORT,
    tab: "Khám mắt",
  },
  {
    menuKey: "baoCaoTongHop",
    tabKey: tabKeys.COMBINE_REPORT.TU_VAN_REPORT,
    tab: "Tư vấn",
  },
  {
    menuKey: "baoCaoTongHop",
    tabKey: tabKeys.COMBINE_REPORT.GIOI_TINH_REPORT,
    tab: "Giới tính",
  },
  {
    menuKey: "baoCaoTongHop",
    tabKey: tabKeys.COMBINE_REPORT.CHAT_LUONG_REPORT,
    tab: "Chất lượng",
  },
  {
    menuKey: "baoCaoTongHop",
    tabKey: tabKeys.COMBINE_REPORT.KINH_REPORT,
    tab: "Kính",
  },
  {
    menuKey: "deNghiMuaSam",
    tabKey: tabKeys.PROPOSE_SHOPPING.LIST,
    tab: "Danh sách đề nghị mua sắm",
  },
  {
    menuKey: "deNghiMuaSam",
    tabKey: tabKeys.PROPOSE_SHOPPING.DETAIL,
    tab: "Chi tiết đề nghị mua sắm",
  },
  {
    menuKey: "deNghiMuaSam",
    tabKey: tabKeys.PROPOSE_SHOPPING.CATALOG,
    tab: "Cấu hình danh mục",
  },
  {
    menuKey: "deNghiThanhToan",
    tabKey: tabKeys.PROPOSE_PAY.LIST,
    tab: "Danh sách đề nghị thanh toán",
  },
  {
    menuKey: "deNghiThanhToan",
    tabKey: tabKeys.PROPOSE_PAY.DETAIL,
    tab: "Chi tiết đề nghị thanh toán",
  },

  // PHÂN QUYỀN
  // {
  //   menuKey: "phanQuyen",
  //   tabKey: tabKeys.AUTHORIZATION.ACCOUNT,
  //   tab: "Tài khoản",
  // },
  // {
  //   menuKey: "phanQuyen",
  //   tabKey: tabKeys.AUTHORIZATION.BRANCH,
  //   tab: "Chi nhánh",
  // },
  // // {
  // //   menuKey: "phanQuyen",
  // //   tabKey: tabKeys.AUTHORIZATION.ROLE,
  // //   tab: "Role",
  // // },
  // {
  //   menuKey: "phanQuyen",
  //   tabKey: tabKeys.AUTHORIZATION.FUNCTION,
  //   tab: "Chức năng",
  // },
  // {
  //   menuKey: "phanQuyen",
  //   tabKey: tabKeys.AUTHORIZATION.API,
  //   tab: "API",
  // },
];
const listPhuongThucTT = [
  {value: 0, label: "Tiền mặt"},
  {value: 1, label: "Chuyển khoản"},
  {value: 2, label: "Quẹt thẻ"},
];
const listTrangThaiMuaSam = [
  {
    value: TRANG_THAI_MUA_SAM.NHAP,
    label: "Nháp",
  },
  {value: TRANG_THAI_MUA_SAM.CHO_DUYET, label: "Đã gửi - Chờ TBP duyệt"},
  {
    value: TRANG_THAI_MUA_SAM.TRUONG_BP_DA_DUYET,
    label: "TBP duyệt - Chờ KT duyệt",
  },
  {
    value: TRANG_THAI_MUA_SAM.KE_TOAN_DA_DUYET,
    label: "KT duyệt - Chờ BGD duyệt",
  },
  {value: TRANG_THAI_MUA_SAM.GD_DA_DUYET, label: "Đã duyệt"},
];
const randomId = function (length = 6) {
  return Math.random()
    .toString(36)
    .substring(2, length + 2);
};
const listDiaDiemMuaSam = Object.values(DIA_DIEM_MUA_SAM).map(e => ({
  value: e,
  label: e,
  key: randomId(),
}));

const listBoPhanMuaSam = Object.values(BO_PHAN_MUA_SAM).map(e => ({
  value: e,
  label: e,
  key: randomId(),
}));
const listNguonThanhToanMuaSam = Object.values(NGUON_THANH_TOAN).map(e => ({
  value: e,
  label: e,
  key: randomId(),
}));
const listChiPhiChinhMuaSam = Object.values(CHI_PHI_CHINH).map(e => ({
  value: e,
  label: e,
  key: randomId(),
}));
export {
  listGender,
  listTTPhieuKho,
  listNhomThuoc,
  listTT_ThuocKho,
  listTTPhieuVTYT,
  listNguonVTYT,
  listTTPhieuKham,
  listTT_Don_Kinh,
  listMarriage,
  listClassification,
  listBacSy1,
  listBacSy2,
  listMenu,
  listTab,
  listPhuongThucTT,
  listTrangThaiMuaSam,
  listDiaDiemMuaSam,
  listBoPhanMuaSam,
  listNguonThanhToanMuaSam,
  listChiPhiChinhMuaSam,
};
